import { FC, Suspense } from 'react';
import Footer from './containers/footer/Footer';
import LeftSidebar from './containers/left-sidebar/LeftSidebar';
import RightSidebar from './containers/right-sidebar/RightSidebar';
import { Outlet } from 'react-router-dom';
import Loading from './components/splash/Loading';
import Header from './containers/header/Header';
import MainMap from '../features/main-map/MainMap';
import RouteStateManager from '../routing/RouteStateManager';

const Layout: FC = () => {
	return (
		<div className="flex flex-col h-screen">
			<RouteStateManager />
			<header className="h-16 bg-msi-white-color text-white flex items-center justify-center p-2">
				<Header />
			</header>
			<div className="flex flex-1">
				<aside className="z-30">
					<LeftSidebar />
				</aside>

				<main className="flex-1 z-10">
					{/* Always render the map */}
					<div className="static w-full h-full">
						<Suspense fallback={<Loading text="Loading Map" />}>
							<MainMap />
						</Suspense>
					</div>

					{/* Other pages will render here, overlaying the map */}
					<Outlet />
				</main>

				<aside className="z-20">
					<RightSidebar />						
				</aside>
			</div>
			<footer className="h-10 bg-msi-darkgrey-color text-white flex items-center justify-left pl-2">
				<Footer />
			</footer>
		</div>
	);
};

export default Layout;
